
  module.exports =
  {
    search: require('./FibreNode/search'),
    orders: require('./FibreNode/orders'),
    add: require('./FibreNode/add'),
    edit: require('./FibreNode/edit'),
    pay: require('./FibreNode/pay'),
  }